/* eslint prefer-destructuring: 0,  react/jsx-curly-brace-presence: 0, react/jsx-wrap-multilines: 0 */
import React, { ChangeEvent, FunctionComponent, useState } from 'react';
import { FormField, Upload, UploadContainer } from '@vwfs-bronson/bronson-react';
import { useField } from 'formik';
import { StipulationFileRecord } from '../../types/files';
import { FileUploadItems } from './file-upload-items/FileUploadItems';

export type FileUploadProps = {
  name: string;
  descriptionText?: string;
  descriptionSupplementaryText?: string;
  buttonText?: string;
  error?: string;
  className?: string;
  multiple?: boolean;
  clearFileList?: boolean;
  canDelete?: boolean;
  onChange?: (
    event: any,
    onFileUploadProgress?: (percentCompleted: number, bytesSent: number, totalBytes: number) => string | void
  ) => void;
  onFileRemove?: (fileId?: string) => void;
  onFileDownload?: (fileId?: string) => void;
  hasError?: boolean;
  loading?: boolean;
};

export const FileUpload: FunctionComponent<FileUploadProps> = ({
  descriptionText,
  descriptionSupplementaryText,
  buttonText,
  multiple,
  onChange,
  error,
  hasError,
  loading = false,
  onFileRemove,
  onFileDownload,
  canDelete = true,
  ...rest
}) => {
  const [filesList] = useField<StipulationFileRecord[]>(rest.name);
  const [uploadProgress, setUploadProgress] = useState(0);

  const removeFile = (fileId?: string): void => {
    if (onFileRemove) {
      onFileRemove(fileId);
    }
  };

  const downloadFile = (id: string): void => {
    if (onFileDownload) {
      onFileDownload(id);
    }
  };

  const onUploadProgress = (percentCompleted: number) => {
    setUploadProgress(percentCompleted);
  };
  const fileChangedHandler = (event: ChangeEvent<HTMLInputElement>): void => {
    if (onChange) {
      onChange(event, onUploadProgress);
    }
    // Clear the input field value after a file is uploaded, allowing the user to upload the same file again if they remove it or if an error occurs
    (document.getElementById(rest.name) as HTMLInputElement).value = '';
  };
  const getFilesList = (): StipulationFileRecord[] => {
    if (Array.isArray(filesList.value)) {
      return filesList.value;
    }
    return filesList.value ? [filesList.value] : [];
  };
  return (
    <FormField type="input" testId={`upload-form-field-${rest.name}`}>
      <UploadContainer
        uploadItemsLabel=""
        className="u-pt-none"
        upload={
          <>
            <Upload
              id={rest.name}
              onChange={(e: ChangeEvent<HTMLInputElement>): void => fileChangedHandler(e)}
              descriptionText={descriptionText}
              descriptionSupplementaryText={descriptionSupplementaryText}
              buttonText={buttonText}
              multiple={multiple}
              loading={loading}
              {...rest}
            />
            {error ? <div className="c-error-message">{error}</div> : null}
          </>
        }
      >
        <FileUploadItems
          files={getFilesList()}
          removeFile={removeFile}
          downloadFile={downloadFile}
          hasError={hasError}
          progressValue={uploadProgress.toString()}
          canDelete={canDelete}
        />
      </UploadContainer>
    </FormField>
  );
};
